module.exports = __webpack_public_path__ + "img/research_1.b5cd1f28.png";